import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="py-32 text-center">
      <div className="max-w-xl mx-auto px-6">
        <span className="eyebrow">404</span>
        <h1 className="mt-4 font-serif-display text-5xl text-white">Page not found</h1>
        <p className="mt-4 text-white/70">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn-primary mt-8" data-testid="notfound-home-link">
          Back to home
        </Link>
      </div>
    </section>
  );
}
